// extracted by mini-css-extract-plugin
export var boxItems = "_c5-1";
export var boxItemsLg = "_c5-2";
export var button = "_c5-7";
export var buttonHoverless = "_c5-9";
export var buttonLg = "_c5-8";
export var filterGroupBox = "_c5-0";
export var icon = "_c5-3";
export var iconSecondary = "_c5-6";
export var iconWrapper = "_c5-4";
export var iconWrapperLg = "_c5-5";
export var truncatedLabel = "_c5-a";